/* eslint-disable max-len */
import * as Constants from './constants';

export const addRequest = (data, pageMode) => ({
  type: Constants.ADD_REQUEST,
  data,
  pageMode,
})
export const addSuccess = result => ({
  type: Constants.ADD_SUCCESS,
  result,
})
export const addError = error => ({
  type: Constants.ADD_ERROR,
  error,
})

export const getRequest = questionId => ({
  type: Constants.GET_REQUEST,
  questionId,
})
export const getSuccess = result => ({
  type: Constants.GET_SUCCESS,
  result,
})
export const getError = error => ({
  type: Constants.GET_ERROR,
  error,
})

export const addClear = () => ({
  type: Constants.ADD_CLEAR
})

export const ownerRequest = owner => ({
  type: Constants.OWNER_REQUEST,
  owner,
})
export const ownerSuccess = result => ({
  type: Constants.OWNER_SUCCESS,
  result,
})
export const ownerError = error => ({
  type: Constants.OWNER_ERROR,
  error,
})
